import { useEffect, useState } from "react";

export const useCountMinute = () =>{
  const [seconds, setSeconds] = useState(0);
  
  useEffect(() => {
    if (seconds > 0) {
      const interval = setInterval(() => {
        setSeconds(prevSeconds => prevSeconds - 1);
      }, 1000);

      return () => clearInterval(interval); // Clean up the interval on component unmount
    }
  }, [seconds]);

  return{
    seconds,
    setSeconds
  }
}